import * as Icons from '../../../assets/images'; // Import all images as an object

// Standalone navigation items
export const StandaloneNavItems = [
  { tabName: 'Dashboard', icon: 'faDash', moduleKey: 'dashboard' },
  { tabName: 'Knowledge Base', icon: 'faSchool', moduleKey: 'knowledge-base' },
];

// Grouped navigation items
export const GroupedNavItems = {
  'AI Assistant': {
    icon: 'faApp',
    items: [
      { tabName: 'Chat', icon: 'faMsg', moduleKey: 'chat' },
      { tabName: 'Playground', icon: 'faCompare', moduleKey: 'playground' },
      { tabName: 'Agents', icon: 'faOnboard', moduleKey: 'agent' },
    ],
  },
  Integration: {
    icon: 'faOnboard',
    items: [
      { tabName: 'Automator', icon: 'faSettings', moduleKey: 'automator' },
      { tabName: 'Gateway', icon: 'faOnboard', moduleKey: 'gateway' },
      { tabName: 'Assistant', icon: 'faApp', moduleKey: 'assistant' },
    ],
  },
  'Admin Settings': {
    icon: 'faConfig',
    items: [
      { tabName: 'Users', icon: 'faUsers', moduleKey: 'users' },
      { tabName: 'Roles', icon: 'faShieldAlt', moduleKey: 'roles' },
      { tabName: 'Teams', icon: 'faTeam', moduleKey: 'team' },
      { tabName: 'LLM', icon: 'faConfig', moduleKey: 'llm' },
      { tabName: 'Embedding', icon: 'faEmbed', moduleKey: 'embedding' },
    ],
  },
  Settings: {
    icon: 'faConfig',
    items: [
      { tabName: 'Budget Settings', icon: 'faBudget', moduleKey: 'budget settings' },
      { tabName: 'PII Configuration', icon: 'faPii', moduleKey: 'chat pii' },
    ],
  },
};

// Legacy array for backward compatibility
export const UserModuleNavItems = [
  ...StandaloneNavItems,
  ...Object.values(GroupedNavItems).flatMap((group) => group.items),
];

export const adminModuleNames = [
  'users',
  'roles',
  'teams',
  'llm',
  'embedding',
  'budget-settings',
  'chat-pii',
];

export const MenuText = 'MENU';

export const AdminSettingsText = 'Admin Settings';

// Mapping for icons
export const iconMapping: Record<string, { active: string; inactive: string }> = {
  faDash: { active: Icons.ActiveDash, inactive: Icons.InactiveDash },
  faUsers: { active: Icons.ActiveUsers, inactive: Icons.InactiveUsers },
  faShieldAlt: { active: Icons.ActiveRoles, inactive: Icons.InActiveRoles },
  faTeam: { active: Icons.GroupAdd, inactive: Icons.GroupAdd },
  faMsg: { active: Icons.ActiveChat, inactive: Icons.InactiveChat },
  faConfig: {
    active: Icons.ActiveSettings,
    inactive: Icons.InactiveSettings,
  },
  faApp: { active: Icons.ActiveCreateApp, inactive: Icons.UnActiveCreateApp },
  faOnboard: {
    active: Icons.ActiveOnboardApps,
    inactive: Icons.InactiveOnboardApps,
  },
  faCompare: {
    active: Icons.ActivePlayGround,
    inactive: Icons.InActivePlayGround,
  },
  faSettings: {
    active: Icons.AutoMatorSettingsActive,
    inactive: Icons.AutoMatorSettingsUnActive,
  },
  faSchool: {
    active: Icons.ActiveSchool,
    inactive: Icons.InActiveSchool,
  },
  faEmbed: {
    active: Icons.EmbeddedActive,
    inactive: Icons.EmbeddedInactive,
  },
  faBudget: {
    active: Icons.ActiveBudget,
    inactive: Icons.InactiveBudget,
  },
  faPii: {
    active: Icons.ActivePii,
    inactive: Icons.InactivePii,
  },
};
